import {
  DashboardPricingPanel,
  DashboardSaveBar,
  DashboardServicesPanel,
  DashboardSpecialistsPanel,
} from '@/components/dashboard/DashboardPanels';
import { DashboardHowItWorksLink } from '@/pages/dashboard/DashboardHelpPage';
import { useDashboardSite } from '@/pages/dashboard/DashboardSiteContext';

export default function DashboardCatalogPage() {
  const { isStarterPlan } = useDashboardSite();

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Catalog</h2>
        <p className="text-sm text-muted-foreground">
          Specialists, services, and pricing.{' '}
          <DashboardHowItWorksLink hash="pages" />
        </p>
      </div>
      {isStarterPlan ? (
        <p className="rounded-md border border-dashed bg-muted/30 px-3 py-2 text-xs text-muted-foreground">
          Catalog is locked on Starter. Upgrade to Pro to configure services, specialists, and prices.
        </p>
      ) : null}
      <DashboardSpecialistsPanel />
      <DashboardServicesPanel />
      <DashboardPricingPanel />
      <DashboardSaveBar />
    </div>
  );
}
